import { gradeTypes } from '$variables/constants';

const shouldShowExportButton = ({ mappedAssignments, assignments }) => {
  // should not show export button if there is no mappedAssignments
  if (mappedAssignments.length === 0) {
    return false;
  }

  // should display export button if there is only one mappedAssignment
  if (mappedAssignments.length === 1) {
    return true;
  }

  const mappedAssignmentIds = mappedAssignments.map(({ id }) => id);
  const assignment = assignments.find(({ id }) =>
    mappedAssignmentIds.includes(id)
  );

  // return false if all mapped assignments are removed
  // or assignments have not been fetched
  if (!assignment) {
    return false;
  }

  // don't check weightage on non-percentage mappings
  if (assignment.gradeType !== gradeTypes.percentage) {
    return true;
  }

  const totalWeightages = mappedAssignments.reduce(
    (total, { weightage }) => total + weightage,
    0
  );

  return totalWeightages === 100;
};

export default shouldShowExportButton;
